class SchemeManager {
    #device;

    constructor(device){
        this.#device = device;
    }

    async getSchemes(){
        if(this.#device === 'android'){
            const str = window.Android.getSchemes();
            if(str){
                const str_arr = (str + '').split('action?');
                const params_str = str_arr[1];
                const params = new URLSearchParams(params_str);

                return {
                    action : params.get('action'),
                    param0 : params.get('param0'),
                    param1 : params.get('param1'),
                    param2 : params.get('param2'),
                }
            }

            return str;
            // return {action : this.#action, param0 : this.#param0, param1 : this.#param1, param2 : this.#param2}
        }else if(this.#device === 'ios'){
            window.webkit.messageHandlers.ios.postMessage({cmd : 'setScheme'});

            return new Promise((resolve)=>{
                this.completeScheme = (data) => {
                    if(!data) resolve(null);
                    resolve(this.parseIOSScheme(data))
                }
            });
        }
    }

    parseIOSScheme(data){
        const str_arr = (data + '').split('//?');
        const params_str = str_arr[1];

        const params = new URLSearchParams(params_str);

        return {
            action : params.get('action'),
            param0 : params.get('param0'),
            param1 : params.get('param1'),
            param2 : params.get('param2'),
        }
    }

    goScreenFromScheme(data){
        const scheme = this.parseIOSScheme(data)
        this.goScreen(scheme.action, scheme.param0, scheme.param1, scheme.param2);
    }

    goScreen(){}

    // async completeScheme(){
    //
    // }

}


export default SchemeManager;